const APPOINTMENTS_KEY = ['appointments']

const selfDependentId = dependentAccount =>
  dependentAccount?.patientId ?? 'self'

export const appointmentsKeys = {
  all: APPOINTMENTS_KEY,
  upcoming: (patientId, dependentAccount) => [
    ...APPOINTMENTS_KEY,
    'upcoming',
    patientId ?? null,
    selfDependentId(dependentAccount)
  ],
  past: (patientId, dependentAccount) => [
    ...APPOINTMENTS_KEY,
    'past',
    patientId ?? null,
    selfDependentId(dependentAccount)
  ],
  documents: (patientId, dependentAccount, encounterIds) => [
    ...APPOINTMENTS_KEY,
    'documents',
    patientId ?? null,
    selfDependentId(dependentAccount),
    [...(encounterIds ?? [])].sort()
  ]
}
